import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Routes } from 'src/components/common/router/constants';
import { saveJWTToken } from 'src/utils/auth';

export const AuthCallback = () => {
  let [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      saveJWTToken(token);
      window.location.href = Routes.home.path;
    }
  }, [token]);

  return null;
};

export default AuthCallback;
